import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CurrencyProvider } from './contexts/CurrencyContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Layout } from './components/Layout';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { SearchPage } from './pages/SearchPage';
import { VehicleDetailsPage } from './pages/VehicleDetailsPage';
import { DashboardPage } from './pages/DashboardPage';
import { CompanyDashboardPage } from './pages/CompanyDashboardPage';
import { ProfilePage } from './pages/ProfilePage';
import { ReservationsPage } from './pages/ReservationsPage';
import { CompanyLayout } from './components/CompanyLayout';
import { ReservationConfirmationPage } from './pages/ReservationConfirmationPage';
import { COMPANY_NAVIGATION_GROUPS, COMPANY_ROUTE_DEFINITIONS } from './navigation/companyNavigation';
import { APP_ROUTES, APP_ROUTE_SEGMENTS } from './routing/appRoutes';

function App() {
  const companyRoutesByGroup = COMPANY_NAVIGATION_GROUPS.map((group) => ({
    ...group,
    routes: COMPANY_ROUTE_DEFINITIONS.filter((route) => route.groupId === group.id),
  }));

  return (
    <AuthProvider>
      <CurrencyProvider>
      <Routes>
        {/* Public booking/search page - full page, no app chrome (blue bar). */}
        <Route path={APP_ROUTES.root} element={<SearchPage />} />

        {/* Public Routes */}
        <Route path={APP_ROUTE_SEGMENTS.base} element={<Layout />}>
          <Route index element={<Navigate to={APP_ROUTES.root} replace />} />
          <Route path={APP_ROUTE_SEGMENTS.login} element={<LoginPage />} />
          <Route path={APP_ROUTE_SEGMENTS.register} element={<RegisterPage />} />
          <Route path={`${APP_ROUTE_SEGMENTS.vehicles}/:id`} element={<VehicleDetailsPage />} />
          <Route
            path={`${APP_ROUTE_SEGMENTS.reservationConfirmation}/:id`}
            element={<ReservationConfirmationPage />}
          />
        </Route>

        {/* Protected Routes */}
        <Route path={APP_ROUTE_SEGMENTS.base} element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route path={APP_ROUTE_SEGMENTS.dashboard} element={<DashboardPage />} />
          <Route path={APP_ROUTE_SEGMENTS.profile} element={<ProfilePage />} />
          <Route path={APP_ROUTE_SEGMENTS.reservations} element={<ReservationsPage />} />
        </Route>

        {/* Company Management Routes with Sidebar */}
        <Route path={APP_ROUTE_SEGMENTS.base} element={<ProtectedRoute><CompanyLayout /></ProtectedRoute>}>
          <Route path={APP_ROUTE_SEGMENTS.companyDashboard} element={<CompanyDashboardPage />} />
          {companyRoutesByGroup.map((group) => (
            <Route key={group.id} path={group.segment}>
              {group.routes.map((route) => {
                const PageComponent = route.component;
                const routeElement = route.requiredRole || route.requiredPermission ? (
                  <ProtectedRoute
                    requiredRole={route.requiredRole}
                    requiredPermission={route.requiredPermission}
                  >
                    <PageComponent />
                  </ProtectedRoute>
                ) : (
                  <PageComponent />
                );

                return (
                  <Route
                    key={route.id}
                    path={route.segment}
                    element={routeElement}
                  />
                );
              })}
            </Route>
          ))}
        </Route>

        <Route path="*" element={<Navigate to={APP_ROUTES.public.search} replace />} />
      </Routes>
      </CurrencyProvider>
    </AuthProvider>
  );
}

export default App;
